import { render, staticRenderFns } from "./ApplicationSummary.vue?vue&type=template&id=a9007060&scoped=true&"
import script from "./ApplicationSummary.vue?vue&type=script&lang=js&"
export * from "./ApplicationSummary.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationSummary.vue?vue&type=style&index=0&id=a9007060&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9007060",
  null
  
)

export default component.exports